/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './external-ad-unit-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {ExternalAdUnitApiService, ExternalAdUnitModel} from './external-ad-unit-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {APP_SHARED} from '../common/app-shared';
import {ADMIN_RESOURCE_PAGES} from '../common/controller/admin-resource-pages';
import {ObjectNotesButtonComponent} from '../common/directives/notes/object-notes-button.component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, ...ADMIN_RESOURCE_PAGES, ObjectNotesButtonComponent],
  selector: 'adn-external-ad-unit-list-page',
  template
})
export class ExternalAdUnitListPageComponent implements OnInit {
  readonly itemStateName = 'app.inv.external-ad-units.external-ad-unit';
  readonly demandSourceStateName = 'app.adm.external-demand-sources.external-demand-source';

  columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: '', label: 'externalDemandSource', sortable: false},
    {param: 'externalSiteId'},
    {param: 'externalAdUnitId'},
    {param: 'externalAdType'},
    {param: 'width', label: 'dimensions'}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<ExternalAdUnitModel>(
    inject(ExternalAdUnitApiService),
    {listId: 'fullExternalAdUnitList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
